import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";
import clsx from "clsx";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,

    background: theme.palette.tabHeaderBackground,
    border: `1px solid ${theme.mode === "light" ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.10)"}`,
    boxShadow:
      theme.mode === "light"
        ? "0 10px 30px rgba(0,0,0,0.06)"
        : "0 10px 30px rgba(0,0,0,0.25)",
  },

  // ✅ Barra de busca “pill” premium e alinhada
  serachInputWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    height: 44,
    background: theme.palette.optionsBackground,
    borderRadius: 999,
    padding: "0 10px",
    border: `1px solid ${theme.mode === "light" ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.18)"}`,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.75),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    transition: "0.18s ease",

    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      boxShadow:
        theme.mode === "light"
          ? `0 0 0 3px ${theme.palette.primary.main}22`
          : `0 0 0 3px ${theme.palette.primary.main}22`,
    },
  },

  searchIcon: {
    color: theme.mode === "light" ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.65)",
    marginLeft: 4,
    marginRight: 2,
  },

  searchInput: {
    flex: 1,
    border: "none",
    height: 40,
    fontSize: 13,
    padding: "0 6px",
  },

  // ✅ Ícones do topo (filtro/switch) com padrão fixo
  iconBtnSm: {
    height: 32,
    width: 32,
    borderRadius: 10,
    border: `1px solid ${theme.mode === "light" ? "rgba(0,0,0,0.16)" : "rgba(255,255,255,0.18)"}`,
    background: "transparent",
    transition: "0.18s ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
      transform: "translateY(-1px)",
    },
  },

  icon: {
    color: theme.mode === "light" ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.75)",
    transition: "0.18s ease",
  },

  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },

  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.optionsBackground,
    borderRadius: 14,
    border: `1px solid ${theme.mode === "light" ? "rgba(0,0,0,0.10)" : "rgba(255,255,255,0.12)"}`,
    marginTop: theme.spacing(0.25),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: "8px 10px",

    boxShadow:
      theme.mode === "light"
        ? "0 10px 22px rgba(0,0,0,0.06)"
        : "0 10px 22px rgba(0,0,0,0.25)",
  },

  // ✅ Botões do bloco superior (all/new/resolve/sort) consistentes
  button: {
    height: 32,
    width: 32,
    border: "1px solid",
    borderColor: theme.mode === "light" ? "rgba(0,0,0,0.16)" : "rgba(255,255,255,0.18)",
    borderRadius: 10,
    marginRight: 8,
    transition: "0.18s ease",
    background: "transparent",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
      transform: "translateY(-1px)",
    },
  },

  // ✅ Tabs internas (Atribuídos/Pendentes/Grupos) mais clean
  tabsRoot: {
    minHeight: 40,
    borderRadius: 12,
    margin: "0 8px 8px 8px",
    background: theme.palette.optionsBackground,
    border: `1px solid ${theme.mode === "light" ? "rgba(0,0,0,0.10)" : "rgba(255,255,255,0.12)"}`,
    overflow: "hidden",
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
    minHeight: 40,
    padding: "6px 8px",
  },

  tabIndicator: {
    height: 4,
    borderRadius: 999,
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },

  customBadge: {
    right: "-10px",
    backgroundColor: "#f44336",
    color: "#fff",
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },

  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "search" && searchInputRef?.current) {
      searchInputRef.current.focus();
    }
    setForceSearch((p) => !p);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch((p) => !p);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch((p) => !p);
    }, 500);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (tags.length === 0) {
      setForceSearch((p) => !p);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch((p) => !p);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch((p) => !p);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch((p) => !p);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch((p) => !p);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch((p) => !p);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch((p) => !p);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch((p) => !p);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
    } else setFilter(true);
    setTab("search");
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />

      {/* ✅ Barra topo premium */}
      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />

        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />

        <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
          <div>
            <Switch
              size="small"
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>

        <Tooltip placement="top" title={isFilterActive ? "Ocultar filtros" : "Mostrar filtros"}>
          <IconButton
            aria-label="filter"
            className={classes.iconBtnSm}
            onClick={() => {
              setIsFilterActive((prevState) => !prevState);
              handleFilter();
            }}
          >
            {isFilterActive ? (
              <FilterAlt className={classes.icon} />
            ) : (
              <FilterAltOff className={classes.icon} />
            )}
          </IconButton>
        </Tooltip>
      </div>

      {filter === true && (
        <>
          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Can
              role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
              perform="tickets-manager:showall"
              yes={() => (
                <Badge
                  color="primary"
                  invisible={!isHoveredAll || isHoveredNew || isHoveredResolve || isHoveredOpen || isHoveredClosed}
                  badgeContent={"Todos"}
                  classes={{ badge: classes.tabsBadge }}
                >
                  <ToggleButton
                    onMouseEnter={() => setIsHoveredAll(true)}
                    onMouseLeave={() => setIsHoveredAll(false)}
                    className={classes.button}
                    value="uncheck"
                    selected={showAllTickets}
                    onChange={() => setShowAllTickets((prevState) => !prevState)}
                  >
                    {showAllTickets ? (
                      <VisibilityIcon className={classes.icon} />
                    ) : (
                      <VisibilityOffIcon className={classes.icon} />
                    )}
                  </ToggleButton>
                </Badge>
              )}
            />

            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={i18n.t("tickets.inbox.closedAllTickets")}
              ContentProps={{
                className: classes.snackbar,
              }}
              action={
                <>
                  <Button className={classes.yesButton} size="small" onClick={CloseAllTicket}>
                    {i18n.t("tickets.inbox.yes")}
                  </Button>
                  <Button className={classes.noButton} size="small" onClick={handleSnackbarClose}>
                    {i18n.t("tickets.inbox.no")}
                  </Button>
                </>
              }
            />

            <Badge
              color="primary"
              invisible={isHoveredAll || !isHoveredNew || isHoveredResolve || isHoveredOpen || isHoveredClosed}
              badgeContent={i18n.t("tickets.inbox.newTicket")}
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => setIsHoveredNew(true)}
                onMouseLeave={() => setIsHoveredNew(false)}
                className={classes.button}
                onClick={() => { setNewTicketModalOpen(true); }}
              >
                <AddIcon className={classes.icon} />
              </IconButton>
            </Badge>

            {user.profile === "admin" && (
              <Badge
                color="primary"
                invisible={isHoveredAll || isHoveredNew || !isHoveredResolve || isHoveredOpen || isHoveredClosed}
                badgeContent={i18n.t("tickets.inbox.closedAll")}
                classes={{ badge: classes.tabsBadge }}
              >
                <IconButton
                  onMouseEnter={() => setIsHoveredResolve(true)}
                  onMouseLeave={() => setIsHoveredResolve(false)}
                  className={classes.button}
                  onClick={handleSnackbarOpen}
                >
                  <PlaylistAddCheckOutlined style={{ color: theme.mode === "light" ? "green" : "#FFF" }} />
                </IconButton>
              </Badge>
            )}

            <Badge
              invisible={!(tab === "open" && !isHoveredAll && !isHoveredNew && !isHoveredResolve && !isHoveredClosed && !isHoveredSort) && !isHoveredOpen}
              badgeContent={i18n.t("tickets.inbox.open")}
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => setIsHoveredOpen(true)}
                onMouseLeave={() => setIsHoveredOpen(false)}
                className={classes.iconBtnSm}
                onClick={() => handleChangeTab(null, "open")}
              >
                <MoveToInboxIcon
                  style={{
                    color: (tab === "open" || isHoveredOpen)
                      ? (theme.mode === "light" ? theme.palette.primary.main : "#FFF")
                      : "#aaa",
                  }}
                />
              </IconButton>
            </Badge>

            <Badge
              color="primary"
              invisible={!(tab === "closed" && !isHoveredAll && !isHoveredNew && !isHoveredResolve && !isHoveredOpen && !isHoveredSort) && !isHoveredClosed}
              badgeContent={i18n.t("tickets.inbox.resolverd")}
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => setIsHoveredClosed(true)}
                onMouseLeave={() => setIsHoveredClosed(false)}
                className={classes.iconBtnSm}
                onClick={() => handleChangeTab(null, "closed")}
              >
                <CheckBoxIcon
                  style={{
                    color: (tab === "closed" || isHoveredClosed)
                      ? (theme.mode === "light" ? theme.palette.primary.main : "#FFF")
                      : "#aaa",
                  }}
                />
              </IconButton>
            </Badge>

            {tab !== "closed" && tab !== "search" && (
              <Badge
                color="primary"
                invisible={!isHoveredSort || isHoveredAll || isHoveredNew || isHoveredResolve || isHoveredOpen || isHoveredClosed}
                badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
                classes={{ badge: classes.tabsBadge }}
              >
                <ToggleButton
                  onMouseEnter={() => setIsHoveredSort(true)}
                  onMouseLeave={() => setIsHoveredSort(false)}
                  className={classes.button}
                  value="uncheck"
                  selected={sortTickets}
                  onChange={() => setSortTickets((prevState) => !prevState)}
                >
                  {!sortTickets ? (
                    <TextRotateUp style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#FFF" }} />
                  ) : (
                    <TextRotationDown style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#FFF" }} />
                  )}
                </ToggleButton>
              </Badge>
            )}
          </Grid>

          <Grid item>
            <TicketsQueueSelect
              selectedQueueIds={selectedQueueIds}
              userQueues={user?.queues}
              onChange={(values) => setSelectedQueueIds(values)}
            />
          </Grid>
        </Grid>
      </Paper>

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          classes={{ root: classes.tabsRoot, indicator: classes.tabIndicator }}
        >
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge overlap="rectangular" classes={{ badge: classes.customBadge }} badgeContent={openCount} color="primary">
                    <MessageSharpIcon style={{ fontSize: 18 }} />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography style={{ marginLeft: 8, fontSize: 10, fontWeight: 700 }}>
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge overlap="rectangular" classes={{ badge: classes.customBadge }} badgeContent={pendingCount} color="primary">
                    <ClockIcon style={{ fontSize: 18 }} />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography style={{ marginLeft: 8, fontSize: 10, fontWeight: 700 }}>
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item>
                    <Badge overlap="rectangular" classes={{ badge: classes.customBadge }} badgeContent={groupingCount} color="primary">
                      <Group style={{ fontSize: 18 }} />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography style={{ marginLeft: 8, fontSize: 10, fontWeight: 700 }}>
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
            />
          )}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={showAllTickets}
            tags={selectedTags}
            users={selectedUsers}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>
    </Paper>
  );
};

export default TicketsManagerTabs;